import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import Avatar from "components/core/Avatar";
import classNames from "components/ui/classNames";
import Link from "next/link";
import colors from "tailwindcss/colors";

export default function BrazilianSubsidiariesContent() {
  const issuer = useBrazilianIssuer();

  return (
    <div className="flex h-fit w-full flex-col gap-4 space-y-1 xl:grid xl:grid-cols-4 xl:space-y-0">
      {issuer.subsidiaries.map((subsidiary) => {
        const linkAs = `/br/${subsidiary.primaryTickerSymbol.toLowerCase()}`;
        const linkHref = "/br/[tickerSymbol]";

        return (
          <Link
            key={subsidiary.primaryTickerSymbol}
            as={linkAs}
            href={linkHref}
            className={classNames(
              "relative flex w-full rounded-xl border border-slate-200 bg-slate-50 no-underline",
              "dark:border-slate-950 dark:bg-slate-800 dark:text-slate-300",
              "group",
            )}
          >
            <div className="flex items-center space-x-4 p-3">
              <Avatar
                src={subsidiary.niceLogo?.url || null}
                hashValue={subsidiary._id}
                alt={subsidiary.name}
                size={40}
                squircle={true}
              />

              <div className="truncate">
                <h3
                  className={classNames(
                    "text-md truncate font-semibold text-gray-800",
                    "hover:underline",
                    "dark:text-slate-200",
                  )}
                >
                  {subsidiary.name}
                </h3>
                <span className="text-xs font-medium text-gray-500 dark:text-gray-400">{subsidiary.sector}</span>
              </div>
            </div>
            <div
              aria-hidden={true}
              className="absolute -left-0.5 top-3 h-[calc(100%-24px)] w-1 rounded-xl"
              style={{
                backgroundColor: subsidiary.niceLogo?.dominantColor || colors.blue[600],
              }}
            />
          </Link>
        );
      })}
    </div>
  );
}
